import { CanActivateFn } from '@angular/router';

export const redirectGuard: CanActivateFn = route => {
  window.location.href = route.data['externalUrl'];
  return true;
};
